import React from "react";
import Section from "../../../pages/Company/AboutUs/Section";
import Features from "../../../pages/Company/AboutUs/Features";
import AboutCompany from "../../../pages/Company/AboutUs/AboutCompany";
import { useLanguage } from "../../../context/LanguageContext";

const AboutUs = () => {
  const { language } = useLanguage();
  document.title = language === "pt" ? "Sobre Nós" : "About Us";

  return (
    <React.Fragment>
      <Section />
      <AboutCompany />
      <Features />
    </React.Fragment>
  );
};

export default AboutUs;
